import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useAccessorySearchModel} from './accessory-search-model'

/**
 * Accessory Search page
 */
export function AccessorySearchPage() {
  const {navigate, t, visibilityModel, showCreateButton, rows, columns} = useAccessorySearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new accessory']),
            onClick: () => navigate(NavigationPathKey.ACCESSORY_CREATION),
          },
        })}
        visibilityModel={visibilityModel}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of accessories'])}
      />
    </SearchTableWrapper>
  )
}
